import { styled, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";
import logo from "../../assets/img/logo_sm.svg";
import { StyledButton } from "../atoms";

export const InfoContainer = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  flex-direction: column;
`;

const PermissionInfoBox = () => {
  const queryClient = useQueryClient();
  const { signoutRedirect } = useAuth();

  // See the note in UserInfo: removeUser() before signoutRedirect() drops the
  // id_token_hint and the Keycloak SSO session survives the logout.
  const signOut = () => {
    queryClient.clear();
    signoutRedirect();
  };

  return (
    <InfoContainer>
      <img
        alt="Logo"
        src={logo}
        height="64"
        width="64"
        style={{ borderRadius: "10px" }}
      />
      <Typography variant="h2" sx={{ margin: "4rem 0" }}>
        You don&apos;t have access to the panel.
      </Typography>
      <StyledButton variant="contained" onClick={signOut}>
        Logout
      </StyledButton>
    </InfoContainer>
  );
};

export { PermissionInfoBox };
